var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsKbDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 48,
    viewBox: "0 0 37 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0L36.5 12H24.5V0ZM21.5 12C21.5 13.6875 22.8125 15 24.5 15H36.5V43.5C36.5 46.0312 34.4375 48 32 48H5C2.46875 48 0.5 46.0312 0.5 43.5V4.5C0.5 2.0625 2.46875 0 5 0H21.5V12ZM27.5 32.3438C28.4375 31.5 28.4375 30.0938 27.5 29.1562L20 21.6562C19.1562 20.8125 17.75 20.8125 16.9062 21.6562L9.40625 29.1562C8.46875 30.0938 8.46875 31.5 9.40625 32.3438C10.25 33.2812 11.6562 33.2812 12.5 32.3438L16.25 28.6875V38.25C16.25 39.5625 17.1875 40.5 18.5 40.5C19.7188 40.5 20.75 39.5625 20.75 38.25V28.6875L24.4062 32.3438C24.7812 32.8125 25.3438 33 26 33C26.5625 33 27.125 32.8125 27.5 32.3438Z",
    fill: "#3CDBC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsKbDocument);
export default __webpack_public_path__ + "static/media/icons_kb_document.9ef2efdf.svg";
export { ForwardRef as ReactComponent };